import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarSparkleFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M9 6c2.25 3.375 5.625 6.75 9 9-3.375 2.25-6.75 5.625-9 9-2.25-3.375-5.625-6.75-9-9 3.375-2.25 6.75-5.625 9-9"
                        fill="currentColor"
                    />
                    <path
                        d="M19 0c1.25 1.875 3.125 3.75 5 5-1.875 1.25-3.75 3.125-5 5-1.25-1.875-3.125-3.75-5-5 1.875-1.25 3.75-3.125 5-5"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HyperstarSparkleFilledSize24Glyph.displayName = 'HyperstarSparkleFilledSize24Glyph';
